export const handleLegacyRoute = () => {
    const route = window.location.hash

    if (route === '#/profile') {
        window.location.hash = '#/account/contact'
    }

    // Partners can only redirect to the ISO country code `dk` for Denmark, but our
    // locale segment is `da`. Rewrite `#/dk` and `#/dk/...` to their `da` equivalent
    // so those links land on the Danish view instead of the country picker.
    if (route === '#/dk' || route.startsWith('#/dk/')) {
        window.location.hash = route.replace(/^#\/dk/, '#/da')
    }
}
